import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import ChangePasswordForm from "../Common/ChangePasswordForm";
import { ShowDangerAlert } from "../../../BonusUi/SweetAlert/ShowDangerAlert/ShowDangerAlert";

const ChangePasswordContainer = () => {
    const navigate = useNavigate();
    const { userId, email, expiry } = useParams<{ userId: string; email: string; expiry: string }>();

    const decodedUserId = useMemo(() => {
        try {
            const id = atob(userId || "");
            return isNaN(Number(id)) ? null : Number(id);
        } catch {
            return null;
        }
    }, [userId]);

    const decodedEmail = useMemo(() => {
        try {
            const mail = atob(email || "");
            return mail.includes("@") ? mail : null;
        } catch {
            return null;
        }
    }, [email]);

    // Decode expiry timestamp from base64 and parse to number
    const decodedExpiry = useMemo(() => {
        try {
            if (!expiry) return null;
            const expStr = atob(expiry);
            const expNum = Number(expStr);
            return isNaN(expNum) ? null : expNum;
        } catch {
            return null;
        }
    }, [expiry]);

    useEffect(() => {
        const nowInSeconds = Math.floor(Date.now() / 1000);

        if (
            !decodedUserId ||
            !decodedEmail ||
            !decodedExpiry ||
            nowInSeconds > decodedExpiry
        ) {
            const message = !decodedUserId || !decodedEmail
                ? "Invalid password reset link."
                : "This reset password link is no longer valid.";

            ShowDangerAlert({
                text: message,
                onConfirm: () => navigate("/login", { replace: true }),
            });

            return;
        }
    }, [decodedUserId, decodedEmail, decodedExpiry, navigate]);


    return (
        <Container fluid className="p-0">
            {decodedUserId && decodedEmail && decodedExpiry && Math.floor(Date.now() / 1000) <= decodedExpiry && (
                <Row className="m-0">
                    <Col xs="12" className="p-0">
                        <ChangePasswordForm userId={decodedUserId} email={decodedEmail} />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default ChangePasswordContainer;
